import AccountingList from '../accounting/AccountingList';
const AccountantAccountingList = () => <AccountingList />;
export default AccountantAccountingList; 